// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------

import $ from 'jquery';
import {tryExecution} from '../_util';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'virtuelle-tour';

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class VirtuelleTour {
  constructor(el) {
    this.el = el;

    $(el).on('click', '.btn', this.onClick.bind(this));
  }

  onClick(e) {
    const modalID = e.currentTarget.getAttribute('data-bs-target');
    const iframe = $(modalID).attr('data-content');
    const iframeContainer = $(modalID).find('.ratio');

    if (iframeContainer.children().length === 1) {
      return;
    }

    iframeContainer.html(iframe);
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => tryExecution(() => new VirtuelleTour(el)));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
